import getIn from 'transmute/getIn';
export const getExtension = getIn(['extension']);
export const getFriendlyName = getIn(['friendlyName']);
export const getNickname = getIn(['nickname']);
export const getPhoneNumber = getIn(['phoneNumber']);
export const getSource = getIn(['source']);